// extracted by mini-css-extract-plugin
module.exports = {"lazy-load":"_9e5970"};